import React, { useState } from "react";
import { useTranslation } from "@me8eon/translation";
import { EonUiIcon, EonUiLink } from "@eon-ui/eon-ui-components-react";
import { useJwtToken } from "@me8eon/react_authentication";
import { MessageWithActionAndData } from "@me8eon/sessions_messages";// Adjust path as needed
import { ShareDataComponent, setSharedData } from "./setShareData";
import Modal from "../modal/Modal";
export interface CopyShareButtonsProps {
    contentToCopy?: string;
    messagesToShare?: MessageWithActionAndData[];
}

export const CopyShareButtons: React.FC<CopyShareButtonsProps> = ({
    contentToCopy,
    messagesToShare,
}) => {
    const t = useTranslation();
    const idToken = useJwtToken();
    const [showPopup, setShowPopup] = useState(false);
    const [sharedId, setShareId] = useState("");
    const [showModal, setShowModal] = useState("");

    const isJsonObject = (value: string | undefined) => {
        if (typeof value !== "string") return false;

        try {
            const parsed = JSON.parse(value);
            return typeof parsed === "object" && parsed !== null;
        } catch (e) {
            return false;
        }
    }

    const handleCopy = async () => {
        if (!contentToCopy || !navigator.clipboard) return;
        try {
            await navigator.clipboard.writeText(contentToCopy);
            setShowModal("copy");
            setTimeout(() => setShowModal(""), 1500);
        } catch (err) {
            console.error("Failed to copy text: ", err);
        }
    };

    const handleShare = async () => {
        if (!messagesToShare) return;

        try {
            const shareId = await setSharedData(messagesToShare, idToken);
            setShowModal("share");
            setShareId(shareId);
        } catch (err) {
            console.error("Failed to share data: ", err);
            alert("Failed to share.");
        }
    };

    const containerStyle: React.CSSProperties = {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        // background: "#ffffff",
        // paddingBottom: "12px",
        // paddingRight: "12px",
        justifyContent: "flex-end",
    };

    const iconButtonStyle: React.CSSProperties = {
        display: "flex",
        alignItems: "center",
        gap: "8px",
    }
    const copyPopupStyle: React.CSSProperties = {
        display: "flex",
        gap: "8px",
        alignItems: "center"
    };

    return (
        <>
            <Modal
                toggleModal={!!showModal}
                closeModal={() => setShowModal("")}
                isCloseIcon={showModal === "share"}
                closeOnBackdrop={false}
            >
                {showModal === "share" ? (
                    <ShareDataComponent sharedId={sharedId} onClose={() => setShowModal("")} />
                ) : (
                    <div style={copyPopupStyle}>
                        <EonUiIcon name="radio_checkbox_tick" style={{ color: "green" }} />
                        {t("chatBot.copiedMsg")}
                    </div>
                )}
            </Modal>
            <span style={containerStyle}>
                {!isJsonObject(contentToCopy) && <div style={iconButtonStyle}>
                    <EonUiLink
                        onClick={handleCopy}
                        title={t("chatBot.copy")}
                        size="small"
                        icon="copy"
                        aria-label="Copy content"
                    />
                </div>}
                <div style={iconButtonStyle}>
                    <EonUiLink
                        onClick={handleShare}
                        icon="share"
                        title={t("chatBot.share")}
                        size="small"
                        aria-label="Share content"
                    />
                </div>
            </span>
        </>
    );
};
